import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import ba from "../assets/images/sidom/svg/Ar.svg";
// import user from "../assets/images/sidom/svg/user.svg";
// import user1 from "../assets/images/sidom/svg/smart18s.svg";
import { useLocation } from "react-router-dom";
import logo from "../assets/images/sidom/fotos/SIDOM-LOGO_NARANJA.png";
// import logo2 from "../assets/images/sidom/fotos/SIDOM-LOGO_BLANCO.png";

// import logoWhite from "../assets/images/logo-white.png";

import ButtonOrange from "../components/ButtonOrang";
export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isDropdownOpen2, setIsDropdownOpen2] = useState(false);
  const [isDropdownOpen3, setIsDropdownOpen3] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = (dropdown) => {
    if (dropdown === "dropdown1") {
      setIsDropdownOpen(!isDropdownOpen);
      if (isDropdownOpen2) setIsDropdownOpen2(false);
      if (isDropdownOpen3) setIsDropdownOpen3(false);
    } else if (dropdown === "dropdown2") {
      setIsDropdownOpen2(!isDropdownOpen2);
      if (isDropdownOpen) setIsDropdownOpen(false);
      if (isDropdownOpen3) setIsDropdownOpen3(false);
    } else if (dropdown === "dropdown3") {
      setIsDropdownOpen3(!isDropdownOpen3);
      if (isDropdownOpen) setIsDropdownOpen(false);
      if (isDropdownOpen2) setIsDropdownOpen2(false);
    }
  };
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
        setIsDropdownOpen2(false);
        setIsDropdownOpen3(false);
      }
    }
    if (isDropdownOpen || isDropdownOpen2 || isDropdownOpen3) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdownOpen, isDropdownOpen2, isDropdownOpen3]);

  return (
    <nav className="fixed  top-0 left-0 w-full z-50  bg-sidom-light  dark:bg-sidom-blue   ">
      <div className="flex flex-wrap  justify-between items-center mx-auto max-w-screen-xl p-4">
        <a
          href="/"
          className="flex items-center space-x-3 logo animate-fade-down animate-once animate-ease-in rtl:space-x-reverse"
        >
          <img src={logo} className="h-6 " alt="" />
          {/* <img src={logo2} className="h-6 hidden dark:inline-block" alt="" /> */}
        </a>
        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          type="button"
          className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-sidom-dark  rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
          aria-controls="navbar-multi-level"
          aria-expanded={isMenuOpen}
        >
          <span className="sr-only">Open main menu</span>
          <svg
            className="w-5 h-5"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 17 14"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M1 1h15M1 7h15M1 13h15"
            />
          </svg>
        </button>
        <div
          ref={dropdownRef}
          className={`${
            isMenuOpen ? "flex" : "hidden"
          } items-center justify-between  w-full  md:flex md:w-auto gap-4 text-sidom-dark dark:text-sidom-light  md:order-1`}
        >
          <ul className="flex flex-col  p-4 md:p-0 mt-4 border border-gray-100 rounded-lg  md:space-x-8 rtl:space-x-reverse md:flex-row md:mt-0 md:border-0 ">
            <li className="relative">
              <button
                onClick={() => toggleDropdown("dropdown1")}
                className="flex items-center justify-between leading-[1.3] w-full py-2 px-3 dark:hover:text-sidom-orange  hover:bg-gray-100 md:hover:bg-transparent md:border-0 hover:text-sidom-orange md:p-0 md:w-auto dark:text-white  dark:focus:text-white dark:hover:bg-gray-700 md:dark:hover:bg-transparent"
              >
                Soluciones
                <svg
                  className="w-2 h-2 ms-2.5"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 10 6"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m1 1 4 4 4-4"
                  />
                </svg>
              </button>
              {isDropdownOpen && (
                <div className="z-10 absolute left-0 mt-2  divide-y  shadow-sm max-w-[400px] ">
                  <ul className="py-8 flex flex-col gap-0 md:gap-2 font-medium leading-[1.3] text-nowrap text-sidom-orange bg-sidom-light border  dark:bg-sidom-blue border-sidom-orange rounded-lg  dark:text-sidom-dark">
                    <li>
                      <Link
                        to="/#section-two"
                        className=" px-4 py-2 flex flex-row hover:text-sidom-orange text-nowrap gap-1 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-sidom-orange cursor-pointer"
                      >
                        <p className="font-bold">SIDOM Global Trade -</p>
                        <p className="text-sidom-blue text-sm dark:text-sidom-light">
                          SUITE Integral
                        </p>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/sidom-smart-reader"
                        className="px-4 py-2 flex flex-row hover:text-sidom-orange gap-1 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-sidom-orange"
                      >
                        <p className="font-bold">SIDOM Smart Reader - </p>
                        <p className="text-sidom-blue dark:text-sidom-light">
                          Document Compliance
                        </p>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/sidom-insurance"
                        className="px-4 py-2 flex flex-row hover:text-sidom-orange gap-1 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-sidom-orange"
                      >
                        <p className="font-bold">SIDOM Insurance - </p>
                        <p className="text-sidom-blue dark:text-sidom-light">
                          COMEX Insurtech
                        </p>
                      </Link>
                    </li>

                    <li>
                      <Link
                        to="/pay"
                        className="px-4 py-2 flex flex-row hover:text-sidom-orange gap-1 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-sidom-orange"
                      >
                        <p className="font-bold">SIDOM Pay - </p>
                        <p className="text-sidom-blue dark:text-sidom-light">
                          Integración financiera
                        </p>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/sidom-mre"
                        className="px-4 py-2 flex flex-row hover:text-sidom-orange gap-1 text-nowrap hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-sidom-orange"
                      >
                        <p className="font-bold">SIDOM MRE - </p>
                        <p className="text-sidom-blue dark:text-sidom-light">
                          Motor de Regímenes Especiales
                        </p>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/sidom-misim"
                        className="px-4 py-2 flex flex-row  hover:text-sidom-orange gap-1  hover:bg-gray dark:hover:bg-gray-600 dark:text-sidom-orange"
                      >
                        <p className="font-bold">SIDOM MiSIM - </p>
                        <p className="text-sidom-blue dark:text-sidom-light">
                          Solución Aduanera
                        </p>

                        <img
                          src={ba}
                          alt="AR"
                          className="ml-2 rounded-full border   w-6 h-6"
                        />
                      </Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>
            <li>
              <Link
                to="/about"
                className="block py-2 px-3 leading-[1.3] hover:text-sidom-orange text-sidom-dark dark:hover:text-sidom-orange  hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:p-0 dark:text-white  dark:hover:bg-gray-700 md:dark:hover:bg-transparent"
              >
                Nosotros
              </Link>
            </li>
            <li className="relative ">
              <button
                onClick={() => toggleDropdown("dropdown2")}
                className="flex items-center justify-between w-full leading-[1.3] hover:text-sidom-orange dark:hover:text-sidom-orange  py-2 px-3 text-sidom-dark hover:bg-gray-100 md:hover:bg-transparent md:border-0  md:p-0 md:w-auto dark:text-white  dark:focus:text-white dark:hover:bg-gray-200 md:dark:hover:bg-transparent"
              >
                Novedades
                <svg
                  className="w-2 h-2 ms-2.5"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 10 6"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m1 1 4 4 4-4"
                  />
                </svg>
              </button>
              {isDropdownOpen2 && (
                <div className="z-10 absolute left-0 mt-2 font-normal bg-sidom-light divide-y rounded-lg shadow-sm w-56 dark:bg-gray-700 dark:divide-gray-600">
                  <ul className="py-2 text-sm font-bold leading-[1.3] text-nowrap text-sidom-orange bg-sidom-light border  dark:bg-sidom-blue border-sidom-orange rounded-lg  dark:text-sidom-dark">
                    <li>
                      <Link
                        to="/sidom-eventos"
                        className="flex flex-row   hover:text-sidom-orange px-4 py-2 hover:bg-gray dark:hover:bg-gray-600 dark:text-sidom-orange"
                      >
                        Networking
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/blogs"
                        className="flex flex-row   hover:text-sidom-orange px-4 py-2 hover:bg-gray dark:hover:bg-gray-600 dark:text-sidom-orange"
                      >
                        Blogs
                      </Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>
            <li className="relative ">
              <button
                onClick={() => toggleDropdown("dropdown3")}
                className="flex items-center justify-between w-full leading-[1.3] hover:text-sidom-orange dark:hover:text-sidom-orange  py-2 px-3 text-sidom-dark hover:bg-gray-100 md:hover:bg-transparent md:border-0  md:p-0 md:w-auto dark:text-white  dark:focus:text-white dark:hover:bg-gray-200 md:dark:hover:bg-transparent"
              >
                Acceso
                <svg
                  className="w-2 h-2 ms-2.5"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 10 6"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m1 1 4 4 4-4"
                  />
                </svg>
              </button>
              {isDropdownOpen3 && (
                <div className="z-10 absolute left-0 mt-2 font-normal  rounded-lg shadow-sm w-56 ">
                  <ul className="py-2 text-sm font-bold leading-[1.3] text-nowrap text-sidom-orange bg-sidom-light dark:bg-sidom-blue border  border-sidom-orange rounded-lg  dark:text-sidom-dark">
                    <li>
                      <Link
                        to="/sidom-eventos"
                        className="block px-4 py-2 hover:text-sidom-orange hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-sidom-orange cursor-pointer"
                      >
                        Acceso a Clientes
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/login"
                        className="block px-4 py-2 hover:text-sidom-orange hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-sidom-orange cursor-pointer"
                      >
                        Acceso Partners
                      </Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>
          </ul>
          <div
            className="flex flex-col md:flex-row lg:flex-row items-center gap-2
           mt-4 md:mt-0"
          >
            <ButtonOrange
              text="SOLICITAR DEMO"
              link="/contact"
              showLineEffect={false}
              customBackground="bg-sidom-light"
              textColor="text-sidom-light"
              borderColor=" border-sidom-orange"
            />
          </div>
        </div>
      </div>
    </nav>
  );
}
